<template>
  <section
    v-if="isSubmitted"
    class="call-back"
  >
    <p
      v-if="isSuccess"
      class="call-back__success"
    >
      {{ $t('contact.success') }}
    </p>
    <p
      v-else
      class="call-back__error"
    >
      {{ $t('contact.error') }}
    </p>
  </section>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      isSubmitted: (state) => state.contact.isSubmitted,
      isSuccess: (state) => state.contact.isSuccess,
    }),
  },
};
</script>

<style lang="scss" scoped>

.call-back {
  color: $black;
  display: flex;
  flex: 1;
  justify-content: center;
  text-align: center;

  &__success {
    color: $c-eucalyptus;
  }

  &__error {
    color: $c-error;
  }
}
</style>
